import { HStack, Text } from '@talos/kyoko';
import type { ReactNode } from 'react';

interface DealCardRowProps {
  label: ReactNode;
  children: ReactNode;
  'data-testid'?: string;
}

/** Label/value detail row shared across the OTC deal confirmation cards. */
export const DealCardRow = ({ label, children, 'data-testid': dataTestId }: DealCardRowProps) => (
  <HStack justifyContent="space-between" data-testid={dataTestId}>
    <Text size="fontSizeSmall" color="colorTextSecondary">
      {label}
    </Text>
    <Text size="fontSizeSmall" weight="fontWeightMedium">
      {children}
    </Text>
  </HStack>
);
